module.exports = __webpack_public_path__ + "static/media/bg_mask.fb30397f.png";